export const materialTestStatusMap = {
  failed: { group: 'closed', label: 'Fail' },
  passed: { group: 'closed', label: 'Pass' },
  cancelled: { group: 'closed', label: 'Cancelled' },
  sent_to_lab: { group: 'open', label: 'Request sent to lab' },
  lab_scheduled: { group: 'open', label: 'Scheduled' },
  lab_activity_completed: { group: 'open', label: 'Visit completed' },
  updated_report: { group: 'open', label: 'Results uploaded' },
};

export const componentNameMap = {
  weather: 'weather',
  bid_items: 'bid-item',
  material_deliveries: 'delivery-usage',
  issues: 'issues',
  activities: 'activities',
  labor: 'labor-equipment',
  equipment: 'labor-equipment',
  internal_tests: 'material-testing',
  activity_codes: 'activity-codes',
  control_forms: 'control-forms',
};

export const activityIdsListTableSortColumnNameMap = {
  activityId: 'Activity Id',
  activityName: 'Activity Name',
  segment: 'Segment',
  location: 'Location',
};

export const activityIdsListTableSortKeyMap = {
  activityId: 'activity_id',
  activityName: 'name',
  segment: 'segment',
  location: 'location',
};
